<template>
    <div>
        <div class="alert alert-warning" v-if="!$root.currentTeam.owner.mms_enabled">
            Your country code does not support MMS messages.
        </div>
        <div class="row">
            <div class="col-6">
                <div class="d-flex justify-content-between align-items-center">
                    <div>
                        <div>&nbsp;</div>
                        <h5 class="form-title">Text (SMS) Preferences</h5>
                    </div>
                    <swell-switch
                        margin="mb-0"
                        truthyLabel="On"
                        falsyLabel="Off"
                        switch-label="Send SMS?"
                        v-model="send_sms"
                    />
                </div>
                <hr>
            </div>

            <div class="col-6">
                &nbsp;
            </div>
        </div>
        <div class="row">
            <div class="col-6">
              <div class="row">
                <div class="col-6">
                <label for="sms">Text (SMS) Message</label>
                </div>
                <div class="col-6">
                  <message-template-selector
                    :message="sms.message"
                    @messageUpdated="sms.message = $event"/>
                </div>
              </div>
                <textarea name="sms" class="form-control" maxlength="254"
                    v-model="sms.message"></textarea>
            </div>

            <div class="col-6">
                <div v-show="!sms.use_location_image" v-if="$root.currentTeam.owner.mms_enabled">
                    <upload-image
                    image-label="SMS image"
                    v-model="sms.image"
                    :url="sms.image_url"
                    />
                </div>
                <div v-if="location_image_available && $root.currentTeam.owner.mms_enabled">
                    <swell-switch
                        margin="mb-0"
                        truthyLabel="On"
                        falsyLabel="Off"
                        switch-label="Use Default Location Image"
                        v-model="sms.use_location_image"
                    />
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import _ from 'lodash'

    export default {
        props: {
            value  : {
                type   : Object,
                default: function () {
                    return {};
                },
            },
            sendSms: {
                type: Boolean
            },
            location_image_available: {
                default: null
            }
        },

        data() {
            return {
                sms     : _.clone(this.value),
                send_sms: this.sendSms,
            }
        },

        watch: {
            sms: {
                handler(value) {
                    return this.$emit('input', value);
                },
                deep: true,
            },

            send_sms() {
                this.$emit('sendSms', this.send_sms);
            }
        }
    }
</script>
